import React, { useContext } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./styles/app.css";
import "./styles/global.css";
import getRoutes from "./routes/routes";
import EventFirstPage from "./pages/EventFirstPage/EventFirstPage";
import DefaultLayout from "./layouts/DefaultLayout";
import AuthLayout from "./layouts/AuthLayout";
import LoginPage from "./pages/LoginPage/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import { LanguageContext } from "./utils/LanguageContext";
import { TranslationsContext } from "./utils/TranslationsContext";
import LoginSinglePage from "./pages/LoginPage/LoginSinglePage";
import PressPage from "./pages/PressPage/PressPage";
import ForgottenPasswordPage from "./pages/ForgottenPasswordPage/ForgottenPasswordPage";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";

function FirstApp() {
  const { language, changeLanguage } = useContext(LanguageContext);
  const { t, isLoading } = useContext(TranslationsContext);

  const routes = getRoutes(t);
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <div className="flex-direction-row app-container">
        <div className="flex-direction-column height-100 width-100">
          <Routes>
            {routes.map((route, index) => (
              <Route
                path={route.to}
                element={
                  <ProtectedRoute>
                    <DefaultLayout setLanguage={changeLanguage}>
                      {route.element}
                    </DefaultLayout>
                  </ProtectedRoute>
                }
                key={index}
              />
            ))}
            <Route
              path="/event/:id"
              element={
                <ProtectedRoute>
                  <DefaultLayout setLanguage={changeLanguage}>
                    <EventFirstPage />
                  </DefaultLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/events/:eventId/persons/:personId"
              element={
                <ProtectedRoute>
                  <DefaultLayout setLanguage={changeLanguage}>
                    <EventFirstPage />
                  </DefaultLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/login"
              element={
                <AuthLayout>
                  <LoginPage />
                </AuthLayout>
              }
            />
            <Route
              path="/login/:id"
              element={
                <AuthLayout>
                  <LoginSinglePage />
                </AuthLayout>
              }
            />
            <Route
              path="/press/:id"
              element={
                <AuthLayout>
                  <PressPage />
                </AuthLayout>
              }
            />
            <Route
              path="/reset-password"
              element={
                <AuthLayout>
                  <ForgottenPasswordPage />
                </AuthLayout>
              }
            />
            {/* Catch-all — any unmatched path (typo, stale/broken link) shows
                a 404 page instead of an empty screen or a silent redirect. */}
            <Route
              path="*"
              element={
                <AuthLayout>
                  <NotFoundPage />
                </AuthLayout>
              }
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default FirstApp;
